/**
 * Куда возвращаться из плеера.
 *
 * Плеер — отдельный экран, и «назад» из него должно приводить туда, откуда
 * зритель ушёл: к списку серий с выбранной озвучкой, а не к описанию тайтла и
 * тем более не к чужому классу источников. Сам плеер этого адреса не знает —
 * он знает только сессию и тайтл, — поэтому адрес запоминает тот, кто уводит в
 * плеер.
 *
 * `sessionStorage`, а не поле в состоянии приложения: между уходом и возвратом
 * страница плеера успевает смонтироваться и размонтироваться, а карточка —
 * собраться заново, и общего живого состояния у них нет. Вкладка при этом своя
 * у каждого зрителя, и переживать её незачем — в отличие от выбора источника и
 * озвучки, которые именно поэтому хранятся на сервере.
 */
const KEY = 'lumos:player-return';

/** Запомнить текущий адрес как точку возврата из плеера. */
export function rememberPlayerReturn(hash: string): void {
  try {
    window.sessionStorage.setItem(KEY, hash);
  } catch {
    // Приватный режим и «запретить сайту хранить данные» — не повод не играть:
    // без записи возврат просто приведёт к описанию тайтла, как раньше.
  }
}

/**
 * Адрес возврата, если он относится к ЭТОМУ тайтлу.
 *
 * Проверка по тайтлу обязательна: в хранилище лежит след прошлого ухода, и
 * после перехода к другому тайтлу он привёл бы зрителя на чужую карточку.
 * `null` — вернуть некуда, вызывающий решает сам.
 */
export function takePlayerReturn(contentId: string | null): string | null {
  if (contentId === null) return null;
  let stored: string | null = null;
  try {
    stored = window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
  if (stored === null) return null;
  const prefix = `#/title/${encodeURIComponent(contentId)}`;
  if (stored !== prefix && !stored.startsWith(`${prefix}/`)) return null;
  return stored;
}
